import TextField from "../../../../components/fields/textField/TextField.vue";
import PeriodoField from "../../../../components/fields/periodoField/PeriodoField.vue";
import SelectField from "../../../../components/fields/selectField/SelectField.vue";
import { ConvocarFeriasService } from "../../../../services/ConvocarFeriasService";


export default {
  name: "AnalisarConvocacao",

  components: {
    TextField,
    PeriodoField,
    SelectField
  },

  props: {
    selected: {
      required: true,
    },
    isOpen: {
      required: true,
    }
  },

  data: () => ({
    id: null,
    form: {},
    justificativaRecusa: "",
    actionsDialogt: false,
    exerciciosOptions: [],

    loading: {
      field: false,
      btn: false,
      btnRefuse: false
    }
  }),

  watch: {
    isOpen: function (isOpen) {
      if (isOpen) {
        this.getDataAnalise();
      }
    },
  },

  beforeMount() {
    this.initializeForm();

  },

  mounted() {
    this.getDataAnalise();
  },

  methods: {
    async getDataAnalise() {
      const response = await ConvocarFeriasService.getByIdFerias(this.selected.idFerias);
      this.id = response.id;
      this.form.justificativa = response.justificativa 
      this.form.dataInicioconvocados = response.data_ini 
      this.form.dataFimconvocados  = response.data_fin
      this.form.numeroDiasconvocados = response.dias 
    },

   
    prepareForm() {
        const formData = new FormData();
        this.sendForm(formData);
        return;
    },

    async sendForm(formData) {
      this.loading.btn = true;
      const response = await ConvocarFeriasService.aprovarConvocacaoFerias(this.id, formData);
      this.loading.btn = false;
      if (response) {
        this.$refs.form.reset();
        this.$emit('on-confirm');
        this.close();
      }
      this.loading.btn = false;
    },

    initializeForm() {
      this.form = {
        justificativa: null,
        dataInicio: this.selected.dataIni,
        dataFim: this.selected.dataFin,
        numeroDias: this.selected.numeroDias,
        numeroDiasconvocados: "",
        dataInicioconvocados: "",
        dataFimconvocados:"",
      }
    },


    
    async refuse() {
      const formData = new FormData();
      formData.append("justificativa_recusa", this.justificativaRecusa);

      this.loading.btnRefuse = true;
      const response = await ConvocarFeriasService.recusarConvocacaoFerias(this.id, formData);
      this.loading.btnRefuse = false;
      this.$emit('on-confirm');
      if (response) {
        this.justificativaDialog = false;
        this.close();
      }
    },

    close() {
      this.$emit("on-close");
    },
    openActionsDialog() {
      this.actionsDialogt = true;
    },
    closeActionsDialog() {
      this.actionsDialog = false;
      this.getFerias();
    }
  }
};